/*
 *  Resumable file upload
 */

window.resumables = {};

function resumableInit(elem) {
    var $elem = $(elem);
    var accept = $elem.prop('accept');

    let identifier = Math.floor(Math.random()*16777215).toString(16);
    $('<input type="text" name="' + $elem.prop('name') + '" class="resumable-hidden"/>').insertAfter($elem);
    $(elem).next().prop('required', $elem.prop('required') && !$elem.data('file'));
    $elem.prop('required', false);
    $elem.hide();
    var resumable = new Resumable({
        target: $elem.data('url'),
        chunkSize: 1 * 1024 * 1024, // 1MB
        simultaneousUploads: 1,
        maxFileSize: 1024 * 1024 * 10,
        maxFileSizeErrorCallback: function (file, errorCount) {
            alert('No se permiten archivos de mas de 10 MBs.');
        },
        testChunks: false,
        throttleProgressCallbacks: 1,
        // Append token to the request - required for web routes
        query:{_token : $('input[name=_token]').val()}
    });

    resumable.assignBrowse($elem);
    resumable.input = elem;

    $elem.prop('accept', accept);
    $elem.data('resumable', identifier);
    $elem.show();
    resumable.on('fileAdded', function (file) {
        this.input.setCustomValidity('El archivo no ha terminado de cargar');
        this.upload();
        $(this.input).data('filename', file.fileName);
        $(this.input).trigger('file-added');
    });

    resumable.on('fileProgress', function (file) {
        $(this.input).data('progress', file.progress());
        $(this.input).data('filename', file.fileName);
        $(this.input).trigger('file-progress');
    });

    resumable.on('fileSuccess', function (file, message) {

        $(this.input).next().val(JSON.parse(message).filepath);
        $(this.input).data('id', JSON.parse(message).id ? JSON.parse(message).id : null);
        $(this.input).data('route', JSON.parse(message).route ? JSON.parse(message).route : null);
        $(this.input).data('filepath', JSON.parse(message).filepath.split('\\').join('/'));
        $(this.input).trigger('file-success');
        this.input.setCustomValidity('');
    });

    resumable.on('fileError', function (file, message) {
        $(this.input).trigger('file-error');
        this.input.setCustomValidity('');
    });
    
    window.resumables[identifier] = resumable;
}

$(document).on('load-resumable', '.resumable-input', function () {
    resumableInit(this);
});

$(document).on('reset-resumable', '.resumable-input', function () {

    let $input = $(this);
    $input.trigger('file-init');

    let $row = $input.closest('.custom-file');
    $row.find('input[type="text"].resumable-hidden').remove();
    let $clone = $input.clone();
    $input.parent().prepend($clone);
    $input.remove();
    $clone.trigger('load-resumable');

});

$(document).ready(function() {
    $('.resumable-input').trigger('load-resumable');
});

/*
 *  Resumable + Bootstrap 4 Custom File Input
 */
$(document).on('file-added', '.custom-file-input.resumable-input', function() {
    $label = $(this).closest('.custom-file').find('.custom-file-label');
    if ($label.length === 0 && $(this).prop('id')) {
        $label = $('.custom-file-label[for="' + $(this).prop('id') + '"]');
    }
    $label.html('<span class="custom-file-progress"></span> - <span class="custom-file-filename"></span>');
    $label.find('.custom-file-filename').html($(this).data('filename'));
    $label.find('.custom-file-progress').html('0%');
});

/*
 *  Resumable + Bootstrap 4 Custom File Input
 */
$(document).on('file-init', '.custom-file-input.resumable-input', function() {
    $label = $(this).closest('.custom-file').find('.custom-file-label');
    if ($label.length === 0 && $(this).prop('id')) {
        $label = $('.custom-file-label[for="' + $(this).prop('id') + '"]');
    }
    $label.html('Seleccionar archivo');
});

$(document).on('file-progress', '.custom-file-input.resumable-input', function() {
    $label = $(this).closest('.custom-file').find('.custom-file-label');
    if ($label.length === 0 && $(this).prop('id')) {
        $label = $('.custom-file-label[for="' + $(this).prop('id') + '"]');
    }
    $label.find('.custom-file-progress').html(Math.floor($(this).data('progress') * 100) + '%');
});

$(document).on('file-success', '.custom-file-input.resumable-input', function() {
    $label = $(this).closest('.custom-file').find('.custom-file-label');
    if ($label.length === 0 && $(this).prop('id')) {
        $label = $('.custom-file-label[for="' + $(this).prop('id') + '"]');
    }
    $label.find('.custom-file-progress').html('OK');
});

$(document).on('file-error', '.custom-file-input.resumable-input', function() {
    $label = $(this).closest('.custom-file').find('.custom-file-label');
    if ($label.length === 0 && $(this).prop('id')) {
        $label = $('.custom-file-label[for="' + $(this).prop('id') + '"]');
    }
    $label.find('.custom-file-progress').html('ERROR');
});
